// NOTE: this can be removed and replaced once we have throw expressions in javascript
// https://github.com/tc39/proposal-throw-expressions
export default function throwError(msg) {
    throw new Error(msg);
}
